import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Innovation Ideas',
      type: 'table',
      content: {
        '{}': {
          query: {
            '`': {
              sort: {
                by: {
                  '@.': '!executive_committee_approval',
                },
                descending: true,
              },
              filter: {
                and: [
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'ideaId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!id',
                          },
                          {
                            '``': {
                              '@$': 'ideaId',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'name',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!name',
                          },
                          {
                            '``': {
                              '@$': 'name',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'status',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!status',
                          },
                          {
                            '``': {
                              '@$': 'status',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'laneOfSupport',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!lane_of_support',
                          },
                          {
                            '``': {
                              '@$': 'laneOfSupport',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'organizationOffering',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@': 'organizationOffering',
                          },
                          {
                            '``': {
                              '@$': 'organizationOffering',
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              target: 'ent:!innovation_ideas:!innovation_idea',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      status: {
                        '{}': {
                          value: {
                            '@.': '!status',
                          },
                        },
                      },
                      jiraIssueKey: {
                        '{}': {
                          value: {
                            '@.': '!jira_issue_key',
                          },
                        },
                      },
                      laneOfSupport: {
                        '{}': {
                          value: {
                            '@.': '!lane_of_support',
                          },
                        },
                      },
                      organizationOffering: {
                        '{}': {
                          value: {
                            '@': 'organizationOffering',
                          },
                        },
                      },
                      executiveCommitteeApproval: {
                        '{}': {
                          value: {
                            '@.': '!executive_committee_approval',
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                organizationOffering: {
                  ref: {
                    attr: 'attr:ent#!innovation_ideas#!innovation_idea:!org_offering',
                  },
                  target: 'dim::!org_offering',
                  quantity: 1,
                  selection: {
                    '@.': '!name',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'organizationOffering',
                  direct: {
                    '{}': {
                      name: 'Organization Offering',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'laneOfSupport',
                  direct: {
                    '{}': {
                      name: 'Lane of Support',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'status',
                  direct: {
                    '{}': {
                      name: 'Status',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'executiveCommitteeApproval',
                  direct: {
                    '{}': {
                      name: 'Executive Committee Approval',
                      type: 'BOOL',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
